<div class="dashboard">

  <div class="dashboard-boxes">

    <div class="dashboard-box __revenue" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Revenue</span>
      <span class="dashboard-box-count">{{ revenue | currency: 'USD': 'symbol' : '1.0-0' }}</span>
    </div>

    <div class="dashboard-box __units-sold" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Units Sold</span>
      <span class="dashboard-box-count">{{unitsSold}}</span>
    </div>

    <div class="dashboard-box __open-orders" (click)="goTo('purchase-orders')" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Open Orders</span>
      <span class="dashboard-box-count">
        {{ orderCounters.openOrdersTotal }} | {{orderCounters.openOrdersAmount | currency: 'USD': 'symbol' : '1.0-0' }}
      </span>
    </div>

    <div class="dashboard-box __pending-sold" (click)="goTo('pending-sold')" [class.preloader]="countersLoading">
      <span class="dashboard-box-heading">Pending PO</span>
      <span class="dashboard-box-count">
        {{ orderCounters.pendingPOTotal }} | {{orderCounters.pendingPOAmount | currency: 'USD': 'symbol' : '1.0-0' }}
      </span>
    </div>

  </div>

  <div class="dashboard-info" *ngIf="orderCounters && orderCounters.missingTrackingTotal > 0">
    <span class="dashboard-info__text">
      <span routerLink="/vendor/purchase-orders">
        You have {{orderCounters.missingTrackingTotal}} purchase order(s) missing tracking
      </span>
    </span>
  </div>

  <div class="dashboard-charts">

    <div class="dashboard-chart">

      <div class="dashboard-chart-heading">
        <h2>Performance</h2>
      </div>

      <div (click)="clickedInsideDatePicker($event)" class="dashboard-chart-date"
        *ngIf="dashboardService.vendorHasItems">
        <div (click)="showDaterangePicker($event)">
          <input type="text" class="form-control" #dashboardDp="bsDaterangepicker" [bsConfig]="bsConfig"
            [bsValue]="dateRangeValues" placement="left" bsDaterangepicker triggers='custom'>
        </div>

        <div class="dashboard-chart-date-wrapper" *ngIf="isDatePickerOpen">
          <div class="dashboard-chart-date-btns">
            <div class="today-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.today"
                (click)="changeDateRanges($event, 0, daterangesEnum.today)">Today</a>
            </div>

            <div class="yesterday-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.yesterday"
                (click)="changeDateRanges($event, 1, daterangesEnum.yesterday)">Yesterday</a>
            </div>

            <div class="last-seven-days">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.last7days"
                (click)="changeDateRanges($event, 7, daterangesEnum.last7days)">Last 7 Days</a>
            </div>

            <div class="last-thirty-days">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.last30days"
                (click)="changeDateRanges($event, 30, daterangesEnum.last30days)">Last 30 Days</a>
            </div>

            <div class="current-month-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.thisMonth"
                (click)="changeDateRanges($event, null, daterangesEnum.thisMonth)">This Month</a>
            </div>

            <div class="last-month-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.lastMonth"
                (click)="changeDateRanges($event, null, daterangesEnum.lastMonth)">Last Month</a>
            </div>

            <div class="custom-range-btn">
              <a class="btn" [class.active]="quickDateRangeSelected === daterangesEnum.customRange"
                (click)="changeDateRanges($event, null, daterangesEnum.customRange)">Custom Range</a>
            </div>
          </div>

          <bs-daterangepicker-inline *ngIf="bsConfig" [bsConfig]="bsConfig" [bsValue]="dateRangeValues"
            (bsValueChange)="onDateValueChange($event)" #inlineDatePicker></bs-daterangepicker-inline>


          <div class="dashboard-chart-date-bottom">
            <a class="btn btn-cancel" (click)="closeDatepicker()">Cancel</a>
            <a class="btn btn-apply" (click)="getPerformanceChartData()">Apply</a>
          </div>

        </div>
      </div>

      <app-chart  #performanceChart
        [series]="performanceChartData?.series" [categories]="performanceChartData?.categories"
        [totalUnits]="totalUnits" [totalRevenue]="totalRevenue" *ngIf="!loadingPerformanceChartData && !isPerformanceChartEmpty">
      </app-chart>

<!-- Empty state -->
      <div class="dashboard-empty-state __perfomance" *ngIf="!loadingPerformanceChartData && isPerformanceChartEmpty">
        <div class="dashboard-empty-state-modal__wrap">
          <div class="dashboard-empty-state-modal">
            <h3>No Sales Yet</h3>
            <p>Your sales will show here once made</p>
          </div>
        </div>

        <div class="dashboard-empty-state__perfomance-chart">
          <div class="dashboard-empty-state__perfomance-text">
            <span>$40</span>
            <span>$30</span>
            <span>$20</span>
            <span>$10</span>
            <span>$0</span>
          </div>
          <div class="dashboard-empty-state__perfomance-img">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="253" preserveAspectRatio="none" viewBox="0 0 529 253"><g fill="none" fill-rule="evenodd"><line x1=".5" x2="528.5" y1="16.5" y2="16.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="75.5" y2="75.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="134.5" y2="134.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="193.5" y2="193.5" stroke="#E0E0E0"/><path stroke="#1A1A1A" stroke-linejoin="round" stroke-width="6" d="M39,252 C39,246.336191 52.5663188,235.898399 60.0163138,232.759584 C79.2018647,224.67637 98.2888374,226.135415 112.24376,226.135415 C136.80769,226.135415 152.92433,205.06019 179.820262,208.255132 C197.777521,210.388258 203.219676,207.362312 221.183227,166.944224 C239.146778,126.526136 248.099041,106.431814 261.270613,106.431814 C307.392423,106.431814 301.984984,48 330.796061,48 C354.006121,48 356.769567,113.362323 375.495994,123.773617 C399.158989,136.929486 396.584494,103.567812 423.518334,105.239169 C453.502126,107.099788 463.147692,181.158306 498.087323,212.661763 C509.818379,223.239115 526.837025,222.711198 529,222.711198" opacity=".05"/><path stroke="#80CB5E" stroke-width="6" d="M39,253 C39,236.415928 79.2075768,169.403367 115.992159,169.403367 C142.094627,169.403367 161.070243,99.1669143 183.510347,101.841369 C189.989544,102.613572 194.425238,107.728357 203.479114,106.339921 C227.450307,102.663875 235.483485,40.8147603 264.980592,37.2149651 C293.408262,33.7456829 313.587659,73.5952818 349.332713,61.2141066 C381.103778,50.20942 385.51118,143.835784 411.223504,173.708514 C417.869685,181.430087 425.158975,173.708514 435.211393,173.708514 C462.808431,173.708514 480.269646,228.205412 498.669308,228.205412 C517.068971,228.205412 515.096739,188.155359 522.858161,177.432436 C524.78364,174.772258 527.291245,173.708514 529,173.708514" opacity=".05"/><line x1=".5" x2="528.5" y1="252.5" y2="252.5" stroke="#E0E0E0"/><line x1=".5" x2=".5" y1="-1" y2="253" stroke="#E0E0E0"/><line x1="528.5" x2="528.5" y1="-1" y2="253" stroke="#E0E0E0"/></g></svg>
          </div>
          <div class="dashboard-empty-state__perfomance-text">
            <span>1k</span>
            <span>750</span>
            <span>500</span>
            <span>250</span>
            <span>0</span>
          </div>
        </div>

        <div class="dashboard-empty-state__perfomance-legend-wrap">
          <div class="dashboard-empty-state__perfomance-legend _units">
            <div class="_qty">
                0
            </div>
            <div>
              <span> Units </span>
              <span class="_line"></span>
            </div>
          </div>
          <div class="dashboard-empty-state__perfomance-legend _revenue">
            <div class="_qty">
                $0
            </div>
            <div>
              <span> Revenues </span>
              <span class="_line"></span>
            </div>
          </div>
        </div>
      </div>

<!-- Preloader -->
      <div class="dashboard-preloader __perfomance" *ngIf="loadingPerformanceChartData">

        <div class="dashboard-preloader-chart">
          <div class="dashboard-preloader-text">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="250" viewBox="0 0 32 250"><g fill="none" fill-rule="evenodd"><rect width="32" height="14" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="59" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="118" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="177" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="236" fill="#EAEAEA" rx="7"/></g></svg>
          </div>
          <div class="dashboard-preloader-img">

            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="253" preserveAspectRatio="none" viewBox="0 0 529 253"><g fill="none" fill-rule="evenodd"><line x1=".5" x2="528.5" y1="16.5" y2="16.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="75.5" y2="75.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="134.5" y2="134.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="193.5" y2="193.5" stroke="#E0E0E0"/><line x1=".5" x2="528.5" y1="252.5" y2="252.5" stroke="#E0E0E0"/><line x1=".5" x2=".5" y1="-1" y2="253" stroke="#E0E0E0"/><line x1="528.5" x2="528.5" y1="-1" y2="253" stroke="#E0E0E0"/></g></svg>
          </div>
          <div class="dashboard-preloader-text">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="250" viewBox="0 0 32 250"><g fill="none" fill-rule="evenodd"><rect width="32" height="14" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="59" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="118" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="177" fill="#EAEAEA" rx="7"/><rect width="32" height="14" y="236" fill="#EAEAEA" rx="7"/></g></svg>
          </div>
        </div>

        <div class="dashboard-preloader-legend-wrap">
          <div class="dashboard-preloader-legend">
            <div class="_qty">
              <span></span>
            </div>
            <div>
              <span> Units </span>
              <span class="_line"></span>
            </div>
          </div>
          <div class="dashboard-preloader-legend">
            <div class="_qty">
              <span></span>
            </div>
            <div>
              <span> Revenues </span>
              <span class="_line"></span>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="dashboard-chart">
      <div class="dashboard-chart-heading">
        <h2>Listing Details</h2>
      </div>
      <div class="dashboard-chart-listing" [class.hide]="listingDetailsChart.isLoading || !dashboardService.vendorHasItems">
        <div class="dashboard-chart-listing__big">
          <app-listing-details #listingDetail></app-listing-details>
          <div class="dashboard-chart-listing__big-counter" *ngIf="dashboardService.totalListing">
            {{ dashboardService.totalListing?.count }}
            <span>Total Listings</span>
          </div>
        </div>
        <div class="dashboard-chart-listing__small">
          <div class="chart-item" *ngFor="let status of dashboardService.listingStatuses"
            [routerLink]="'/vendor/items/status/' + status.name">
            <div class="chart-item-left">
              <span class="chart-item-left__heading"> {{ status.name }}</span>
              <span class="chart-item-left__value">{{ status.count }} Listings</span>
            </div>
            <app-mini-progress-chart [count]='status.count' [percentage]="getPercentageProgress(status.count)"
              [color]="getColorByStatusName(status.name)"></app-mini-progress-chart>
          </div>

        </div>
      </div>

      <div class="dashboard-empty-state __listing-details" *ngIf="!dashboardService.vendorHasItems && !listingDetailsChart.isLoading">
        <div class="dashboard-empty-state__label">Your product listings will display here</div>
        <div class="dashboard-empty-state__listing-details">
          <div class="dashboard-empty-state__listing-details-left">
            <img src="assets/images/vendor/dashboard-empty-state-listing-details-chart@2x.png" width="282" height="282"
              alt="listing details empty" />
          </div>
          <div class="dashboard-empty-state__listing-details-right">
            <img src="assets/images/vendor/dashboard-empty-state-listing-details-list@2x.png" width="198" height="404"
              alt="listing details empty" />
          </div>
        </div>
      </div>

<!-- Preloader Listing details chart -->
      <div class="dashboard-preloader __listing-details" *ngIf="listingDetailsChart.isLoading">

        <div class="dashboard-preloader-chart">
          <div class="dashboard-preloader-img">
           <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="auto" viewBox="0 0 305 305"><path fill="#EAEAEA" d="M152.5,0 C236.723424,0 305,68.2765757 305,152.5 C305,236.723424 236.723424,305 152.5,305 C68.2765757,305 0,236.723424 0,152.5 C0,68.2765757 68.2765757,0 152.5,0 Z M152.5,46 C93.6816741,46 46,93.6816741 46,152.5 C46,211.318326 93.6816741,259 152.5,259 C211.318326,259 259,211.318326 259,152.5 C259,93.6816741 211.318326,46 152.5,46 Z"/></svg>
          </div>
          <div class="dashboard-preloader-details">
            <svg xmlns="http://www.w3.org/2000/svg" width="198" height="404" viewBox="0 0 198 404"><g fill="none" fill-rule="evenodd"><path fill="#FFF" fill-rule="nonzero" d="M0 12.0003513C0 5.3727403 5.37295225 0 11.9952381 0L186.004762 0C192.629549 0 198 5.37395589 198 12.0003513L198 51.9996487C198 58.6272597 192.627048 64 186.004762 64L11.9952381 64C5.37045103 64 0 58.6260441 0 51.9996487L0 12.0003513ZM0 80.0003513C0 73.3727403 5.37295225 68 11.9952381 68L186.004762 68C192.629549 68 198 73.3739559 198 80.0003513L198 119.999649C198 126.62726 192.627048 132 186.004762 132L11.9952381 132C5.37045103 132 0 126.626044 0 119.999649L0 80.0003513Z"/><path fill="#F6F6F6" d="M27.5 42 100.5 42C102.432997 42 104 43.5670034 104 45.5 104 47.4329966 102.432997 49 100.5 49L27.5 49C25.5670034 49 24 47.4329966 24 45.5 24 43.5670034 25.5670034 42 27.5 42ZM27.5 110 100.5 110C102.432997 110 104 111.567003 104 113.5 104 115.432997 102.432997 117 100.5 117L27.5 117C25.5670034 117 24 115.432997 24 113.5 24 111.567003 25.5670034 110 27.5 110ZM31 16 77 16C80.8659932 16 84 19.1340068 84 23 84 26.8659932 80.8659932 30 77 30L31 30C27.1340068 30 24 26.8659932 24 23 24 19.1340068 27.1340068 16 31 16ZM31 84 77 84C80.8659932 84 84 87.1340068 84 91 84 94.8659932 80.8659932 98 77 98L31 98C27.1340068 98 24 94.8659932 24 91 24 87.1340068 27.1340068 84 31 84Z"/><path fill="#F6F6F6" fill-rule="nonzero" d="M170.992598 9C178.729702 9 185 15.2691356 185 23.0074017L185 40.9925983C185 48.7297024 178.730864 55 170.992598 55L153.007402 55C145.270298 55 139 48.7308644 139 40.9925983L139 23.0074017C139 15.2702976 145.269136 9 153.007402 9L170.992598 9ZM170.992598 13 153.007402 13C147.478441 13 143 17.4792706 143 23.0074017L143 40.9925983C143 46.5215594 147.479271 51 153.007402 51L170.992598 51C176.521559 51 181 46.5207294 181 40.9925983L181 23.0074017C181 17.4784406 176.520729 13 170.992598 13ZM170.992598 77C178.729702 77 185 83.2691356 185 91.0074017L185 108.992598C185 116.729702 178.730864 123 170.992598 123L153.007402 123C145.270298 123 139 116.730864 139 108.992598L139 91.0074017C139 83.2702976 145.269136 77 153.007402 77L170.992598 77ZM170.992598 81 153.007402 81C147.478441 81 143 85.4792706 143 91.0074017L143 108.992598C143 114.521559 147.479271 119 153.007402 119L170.992598 119C176.521559 119 181 114.520729 181 108.992598L181 91.0074017C181 85.4784406 176.520729 81 170.992598 81Z"/><path fill="#FFF" fill-rule="nonzero" d="M0,148.000351 C0,141.37274 5.37295225,136 11.9952381,136 L186.004762,136 C192.629549,136 198,141.373956 198,148.000351 L198,187.999649 C198,194.62726 192.627048,200 186.004762,200 L11.9952381,200 C5.37045103,200 0,194.626044 0,187.999649 L0,148.000351 Z"/><path fill="#F6F6F6" d="M27.5 178 100.5 178C102.432997 178 104 179.567003 104 181.5 104 183.432997 102.432997 185 100.5 185L27.5 185C25.5670034 185 24 183.432997 24 181.5 24 179.567003 25.5670034 178 27.5 178ZM31 152 77 152C80.8659932 152 84 155.134007 84 159 84 162.865993 80.8659932 166 77 166L31 166C27.1340068 166 24 162.865993 24 159 24 155.134007 27.1340068 152 31 152Z"/><path fill="#F6F6F6" fill-rule="nonzero" d="M170.992598,145 C178.729702,145 185,151.269136 185,159.007402 L185,176.992598 C185,184.729702 178.730864,191 170.992598,191 L153.007402,191 C145.270298,191 139,184.730864 139,176.992598 L139,159.007402 C139,151.270298 145.269136,145 153.007402,145 L170.992598,145 Z M170.992598,149 L153.007402,149 C147.478441,149 143,153.479271 143,159.007402 L143,176.992598 C143,182.521559 147.479271,187 153.007402,187 L170.992598,187 C176.521559,187 181,182.520729 181,176.992598 L181,159.007402 C181,153.478441 176.520729,149 170.992598,149 Z"/><path fill="#FFF" fill-rule="nonzero" d="M0,216.000351 C0,209.37274 5.37295225,204 11.9952381,204 L186.004762,204 C192.629549,204 198,209.373956 198,216.000351 L198,255.999649 C198,262.62726 192.627048,268 186.004762,268 L11.9952381,268 C5.37045103,268 0,262.626044 0,255.999649 L0,216.000351 Z"/><path fill="#F6F6F6" d="M27.5 246 100.5 246C102.432997 246 104 247.567003 104 249.5 104 251.432997 102.432997 253 100.5 253L27.5 253C25.5670034 253 24 251.432997 24 249.5 24 247.567003 25.5670034 246 27.5 246ZM31 220 77 220C80.8659932 220 84 223.134007 84 227 84 230.865993 80.8659932 234 77 234L31 234C27.1340068 234 24 230.865993 24 227 24 223.134007 27.1340068 220 31 220Z"/><path fill="#F6F6F6" fill-rule="nonzero" d="M170.992598,213 C178.729702,213 185,219.269136 185,227.007402 L185,244.992598 C185,252.729702 178.730864,259 170.992598,259 L153.007402,259 C145.270298,259 139,252.730864 139,244.992598 L139,227.007402 C139,219.270298 145.269136,213 153.007402,213 L170.992598,213 Z M170.992598,217 L153.007402,217 C147.478441,217 143,221.479271 143,227.007402 L143,244.992598 C143,250.521559 147.479271,255 153.007402,255 L170.992598,255 C176.521559,255 181,250.520729 181,244.992598 L181,227.007402 C181,221.478441 176.520729,217 170.992598,217 Z"/><path fill="#FFF" fill-rule="nonzero" d="M0,284.000351 C0,277.37274 5.37295225,272 11.9952381,272 L186.004762,272 C192.629549,272 198,277.373956 198,284.000351 L198,323.999649 C198,330.62726 192.627048,336 186.004762,336 L11.9952381,336 C5.37045103,336 0,330.626044 0,323.999649 L0,284.000351 Z"/><path fill="#F6F6F6" d="M27.5 314 100.5 314C102.432997 314 104 315.567003 104 317.5 104 319.432997 102.432997 321 100.5 321L27.5 321C25.5670034 321 24 319.432997 24 317.5 24 315.567003 25.5670034 314 27.5 314ZM31 288 77 288C80.8659932 288 84 291.134007 84 295 84 298.865993 80.8659932 302 77 302L31 302C27.1340068 302 24 298.865993 24 295 24 291.134007 27.1340068 288 31 288Z"/><path fill="#F6F6F6" fill-rule="nonzero" d="M170.992598,281 C178.729702,281 185,287.269136 185,295.007402 L185,312.992598 C185,320.729702 178.730864,327 170.992598,327 L153.007402,327 C145.270298,327 139,320.730864 139,312.992598 L139,295.007402 C139,287.270298 145.269136,281 153.007402,281 L170.992598,281 Z M170.992598,285 L153.007402,285 C147.478441,285 143,289.479271 143,295.007402 L143,312.992598 C143,318.521559 147.479271,323 153.007402,323 L170.992598,323 C176.521559,323 181,318.520729 181,312.992598 L181,295.007402 C181,289.478441 176.520729,285 170.992598,285 Z"/><path fill="#FFF" fill-rule="nonzero" d="M0,352.000351 C0,345.37274 5.37295225,340 11.9952381,340 L186.004762,340 C192.629549,340 198,345.373956 198,352.000351 L198,391.999649 C198,398.62726 192.627048,404 186.004762,404 L11.9952381,404 C5.37045103,404 0,398.626044 0,391.999649 L0,352.000351 Z"/><path fill="#F6F6F6" d="M27.5 382 100.5 382C102.432997 382 104 383.567003 104 385.5 104 387.432997 102.432997 389 100.5 389L27.5 389C25.5670034 389 24 387.432997 24 385.5 24 383.567003 25.5670034 382 27.5 382ZM31 356 77 356C80.8659932 356 84 359.134007 84 363 84 366.865993 80.8659932 370 77 370L31 370C27.1340068 370 24 366.865993 24 363 24 359.134007 27.1340068 356 31 356Z"/><path fill="#F6F6F6" fill-rule="nonzero" d="M170.992598,349 C178.729702,349 185,355.269136 185,363.007402 L185,380.992598 C185,388.729702 178.730864,395 170.992598,395 L153.007402,395 C145.270298,395 139,388.730864 139,380.992598 L139,363.007402 C139,355.270298 145.269136,349 153.007402,349 L170.992598,349 Z M170.992598,353 L153.007402,353 C147.478441,353 143,357.479271 143,363.007402 L143,380.992598 C143,386.521559 147.479271,391 153.007402,391 L170.992598,391 C176.521559,391 181,386.520729 181,380.992598 L181,363.007402 C181,357.478441 176.520729,353 170.992598,353 Z"/></g></svg>
          </div>
        </div>

      </div>

    </div>

  </div>

  <div class="dashboard-items-wrap">

    <div class="dashboard-items __just-sold">
      <div class="dashboard-items-heading">
        <h2>Just Sold on HUBX</h2>
      </div>
      <div class="dashboard-items-list" *ngIf="justSoldItems || justSoldScrollLoading || justSoldLoading">
        <ng-container *ngIf="justSoldItems && !justSoldLoading">
          <virtual-scroller [items]="justSoldItems" (vsEnd)="onScrollDownJustSold($event)" [scrollAnimationTime]="0"
            #scrollJustSold>
            <ng-container *ngFor="let item of  scrollJustSold.viewPortItems">
              <app-item-dashboard [item]="item"></app-item-dashboard>
            </ng-container>
            <app-dashboard-just-sold-preloader
              [class.hide]="!justSoldScrollLoading"></app-dashboard-just-sold-preloader>
          </virtual-scroller>
        </ng-container>
        <ng-container *ngIf="justSoldLoading">
          <app-vendor-items-preloader [source]="'dashboardJustSold'"></app-vendor-items-preloader>
        </ng-container>
      </div>

      <div *ngIf="!justSoldItems && !justSoldLoading" class="dashboard-empty-state">
        <div class="dashboard-empty-state__label">You have no items sold</div>
        <div class="dashboard-empty-state__just-sold-img">
          <img src="assets/images/vendor/dashboard-empty-state-1.png"
            srcset="assets/images/vendor/dashboard-empty-state-1@2x.png 2x" width="286" height="286"
            alt="just sold empty" />
        </div>
      </div>
    </div>

    <div class="dashboard-items __notifications">
      <div class="dashboard-items-heading">
        <h2><span routerLink="/vendor/notifications">Notifications</span></h2>
      </div>

      <div class="dashboard-items-list"
        [hidden]="!notificationCenter?.loading && notificationCenter?.notifications?.length < 1">
        <app-notification-center [isFromDashboard]="true"
          *ngIf="!vendorService.isVendorManager || vendorService.isImpersonationReady"></app-notification-center>
      </div>
      <div class="dashboard-empty-state"
        *ngIf="!notificationCenter?.loading && notificationCenter?.notifications?.length < 1">
        <div class="dashboard-empty-state__label">You have no notifications</div>
        <div class="dashboard-empty-state__notifications">
          <div class="dashboard-empty-state__notifications-row _top">
            <div>
              <div class="dashboard-empty-state__notifications-txt">
                <h3>Get ready to receive notifications from your buyers.</h3>
                <p>Buyers have the ability to notify you sellers 3 ways.</p>
                <ul class="dashboard-empty-state__notifications-list">
                  <li>
                    <img src="assets/images/vendor-icons/32-price-drop.svg" width="32" height="32" alt="price drop" />
                    <p>Waiting for <br />Price Drops</p>
                  </li>
                  <li>
                    <img src="assets/images/vendor-icons/32-back-to-stock.svg" width="32" height="32"
                      alt="back to stock" />
                    <p>Waiting for sold out items <br />to come back to stock</p>
                  </li>
                  <li>
                    <img src="assets/images/vendor-icons/32-more-inventory.svg" width="32" height="32"
                      alt="more inventory" />
                    <p>Waiting for more <br />inventory to be Added</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="dashboard-empty-state__notifications-row _btm">
            <div>
              <div class="dashboard-empty-state__notifications-txt">
                <h3>Instantly notify your buyers!</h3>
                <p>By updating your listing, the below buyers will instantly receive a SMS, Email, and notifications in
                  their HUBX buyers Portal! </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>

<app-error-modal [title]="'Server Error'" [isError]="errorModal.isError400" [bodyText]="errorModal.errorMessage400"
  (onConfirmError)="hideErrorAlert()"></app-error-modal>
